import { getTextAssetCollectionConfig } from '@bingads-webui-campaign-react/pmax-text-input';

const collectionConfig = {
  headlines: {
    labelText: _TL_('Short headline'),
    placeholderText: _TL_('Enter your short headline'),
    fieldName: 'short-headline',
    singleAssetValidationPropsField: 'Headline',
    validationPropsField: 'Headlines',
    addButtonText: _TL_('Add headline'),
    copilotButtonLabel: _TL_('Get recommendations for your short headline'),
    deleteButtonLabel: _TL_('Remove short headline'),
    minCollectionSize: 1,
    maxCollectionSize: 1,
    errorMessage: _TL_('At least one short headlines are required'),
    helpPopupTopic: 'pop_BA_DisplayTemplate_Headline',
    helpPopupAriaLabel: _TL_('Click to learn more about short headlines'),
    inlineRecommendationsTitle: _TL_('Recommended short headlines'),
    inlineRecommendationsHelpTopicKey:
    'pop_BA_Recommendations_Pmax_Shortheadlines',
    inlineRecommendationsHelpTopicAriaLabel: _TL_('Click to learn more about short headlines recommendations'),
    inlineRecommendationsDisabledItemTooltip: _TL_("You've reached the maximum number of short headlines. Please remove one short headline if you'd like to add this recommended short headline."),
    duplicateErrorMessage: _TL_('Duplicate short headlines are not allowed'),
  },
  longHeadlines: {
    labelText: _TL_('Long headline'),
    placeholderText: _TL_('Enter your long headline'),
    fieldName: 'long-headline',
    singleAssetValidationPropsField: 'LongHeadline',
    validationPropsField: 'LongHeadlines',
    addButtonText: _TL_('Add long headline'),
    copilotButtonLabel: _TL_('Get recommendations for your long headline'),
    deleteButtonLabel: _TL_('Remove long headline'),
    minCollectionSize: 1,
    maxCollectionSize: 1,
    errorMessage: _TL_('At least one long headline is required'),
    helpPopupTopic: 'pop_BA_DisplayTemplate_Headline',
    helpPopupAriaLabel: _TL_('Click to learn more about long headlines'),
    inlineRecommendationsTitle: _TL_('Recommended long headlines'),
    inlineRecommendationsHelpTopicKey:
    'pop_BA_Recommendations_Pmax_Longheadlines',
    inlineRecommendationsHelpTopicAriaLabel:
    _TL_('Click to learn more about long headlines recommendations'),
    inlineRecommendationsDisabledItemTooltip:
    _TL_("You've reached the maximum number of long headlines. Please remove one long headline if you'd like to add this recommended long headline."),
    duplicateErrorMessage: _TL_('Duplicate long headlines are not allowed'),
  },
  descriptions: {
    labelText: _TL_('Description'),
    placeholderText: _TL_('Enter a description'),
    fieldName: 'description',
    singleAssetValidationPropsField: 'Description',
    validationPropsField: 'Descriptions',
    addButtonText: _TL_('Add description'),
    minCollectionSize: 1,
    maxCollectionSize: 1,
    errorMessage: _TL_('At least one description is required'),
    helpPopupTopic: 'pop_BA_DisplayTemplate_Description',
    helpPopupAriaLabel: _TL_('Click to learn more about descriptions'),
    inlineRecommendationsTitle: _TL_('Recommended descriptions'),
    inlineRecommendationsHelpTopicKey: 'pop_BA_Recommendations_Pmax_Descriptions',
    inlineRecommendationsHelpTopicAriaLabel:
    _TL_('Click to learn more about descriptions recommendations'),
    inlineRecommendationsDisabledItemTooltip:
    _TL_('You’ve reached the maximum number of descriptions. Please remove one description if you’d like to add this recommended description.'),
    duplicateErrorMessage: _TL_('Duplicate descriptions are not allowed'),

  },
};

export const getLongHeadlineAssetCollectionConfig = i18n => getTextAssetCollectionConfig('longHeadlines', i18n, collectionConfig);

export const getDescriptionAssetCollectionConfig = i18n => getTextAssetCollectionConfig('descriptions', i18n, collectionConfig);

export const getShortHeadlineAssetCollectionConfig = i18n => getTextAssetCollectionConfig('headlines', i18n, collectionConfig);

